module.exports = __webpack_public_path__ + "img/museum.b8f18047.png";